import { InjectionToken } from '@angular/core';

export const GO_MODAL_DATA = new InjectionToken<object>('GO_MODAL_DATA');
